export default "__VITE_PUBLIC_ASSET__f03295ca__"